import Key from "csi/core/Key";
import Widget from "csi/table/Widget";
import declare from "dojo/_base/declare";
import { C8AttributeKey } from "src/c8-platform/type/value";

const ProductColorsTable = declare(Widget, {
	/**
   * @override
   * Doesn't render Color Allocation Matrix if Color Allocation Status is off
   */
	onViewResolveKeysToSkip(skipSet: Set<C8AttributeKey>): void {
		const viewNode = this.getViewNode();

		if (viewNode?.ColorAllocationStatus === "ColorAllocationStatus:Off") {
			skipSet.add(Key.untypedKeyFromParts({
				id: "ColorwayColorSources",
			}));
		}
	},
});

export = ProductColorsTable;
